<template>
  <page-error class="v-error" />
</template>

<script>
  import PageError from '@/common/components/PageError.vue';

  export default {
    name: 'Error',
    components: {
      PageError
    }
  };
</script>
